import React from 'react';
import { FaUser, FaCheck } from 'react-icons/fa';

interface Participante {
  nome: string;
  matricula: string;
  displayName?: string;
  confirmado: boolean;
}

interface IniciativaParticipantesProps {
  participantes: Participante[];
}

export const IniciativaParticipantes: React.FC<IniciativaParticipantesProps> = ({
  participantes,
}) => {
  const confirmados = participantes.filter((p) => p.confirmado).length;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <h3 className="text-sm font-bold text-[#1e3a5f] mt-0 mb-4">
        Participantes da realização ({confirmados} de {participantes.length} confirmados)
      </h3>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-2">
        {participantes.map((participante, index) => (
          <div
            key={index}
            className={`rounded-lg p-2.5 ${
              participante.confirmado
                ? 'bg-green-50 border border-green-200'
                : 'bg-gray-50 border border-gray-200'
            }`}
          >
            <div className="flex items-start gap-2">
              <FaUser className={`${participante.confirmado ? 'text-green-700' : 'text-gray-400'} shrink-0 mt-0.5`} size={16} />
              {participante.confirmado && (
                <FaCheck className="text-green-700 shrink-0 mt-0.5" size={13} />
              )}
              <span className="text-xs text-gray-700 leading-snug">
                {participante.displayName || `${participante.nome} (${participante.matricula})`}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
